'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const LogoDecathlonLockupPrimaryWhiteAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 189 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M58.1509 23.8H71.3949V19.544H63.1909V15.974H70.4569V12.012H63.1909V8.442H71.3949V4.2H58.1509V23.8ZM87.8309 15.358C85.9129 18.41 84.0509 19.684 81.6569 19.684C78.5489 19.684 76.7429 17.5 76.7429 13.706C76.7429 10.108 78.4089 8.316 80.9709 8.316C82.6649 8.316 84.0649 9.072 84.4989 11.592H89.5389C88.9929 6.79 85.9269 3.808 81.0269 3.808C75.3429 3.808 71.6049 7.82599 71.6049 13.986C71.6049 20.188 75.3429 24.192 81.4889 24.192C85.5069 24.192 88.2369 22.512 90.0429 20.244H96.9169V23.8H101.929V4.2H94.8169L87.8309 15.358ZM96.9169 16.31H92.4789L96.9169 9.1V16.31ZM47.3989 4.2H40.0349V23.8H47.3989C53.2369 23.8 57.0029 19.95 57.0029 14C57.0029 8.05 53.2369 4.2 47.3989 4.2ZM47.3289 19.544H45.0749V8.442H47.3289C50.2409 8.442 51.8789 10.5 51.8789 14C51.8789 17.486 50.2409 19.544 47.3289 19.544ZM159.777 3.808C153.855 3.808 149.879 7.826 149.879 14C149.879 20.174 153.855 24.192 159.777 24.192C165.713 24.192 169.675 20.174 169.675 14C169.675 7.82601 165.713 3.808 159.777 3.808ZM159.777 19.684C156.865 19.684 155.031 17.738 155.031 14C155.031 10.262 156.865 8.316 159.777 8.316C162.703 8.316 164.523 10.262 164.523 14C164.523 17.738 162.703 19.684 159.777 19.684ZM103.189 8.442H108.131V23.8H113.171V8.442H118.113V4.2H103.189L103.189 8.442ZM182.541 4.2V14.994L176.045 4.2H170.823V23.8H175.695V12.558L182.457 23.8H187.413V4.2L182.541 4.2ZM142.739 4.2H137.699V23.8H150.341V19.558H142.739V4.2ZM131.203 11.676H124.413V4.2H119.373V23.8H124.413V15.904H131.203V23.8H136.243V4.2H131.203V11.676Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M25.8111 0C14.8668 0 1.25311 11.3236 1.25311 20.7085C1.25311 25.5554 4.97614 28 9.89335 28C13.504 28 17.8733 26.6794 22.088 24.1365V5.40893C20.9641 7.33366 15.6816 15.0888 11.4388 19.2193C9.2752 21.3266 7.5612 22.2398 6.08604 22.2398C4.42823 22.2398 3.64148 21.1159 3.64148 19.4441C3.64148 11.8575 16.4122 1.99498 24.8698 1.99498C28.354 1.99498 30.6018 3.54039 30.6018 6.54692C30.6018 9.30055 28.7333 12.7566 25.5441 15.9458V21.7481C31.1076 17.3507 34.4373 11.7451 34.4373 7.22127C34.4373 2.4586 30.7283 0 25.8111 0Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpLogoDecathlonLockupPrimaryWhiteAsset = forwardRef(LogoDecathlonLockupPrimaryWhiteAsset);

export { VpLogoDecathlonLockupPrimaryWhiteAsset as default };
